// extracted by mini-css-extract-plugin
export var actions = "_9i-8";
export var arrow = "_9i-5";
export var card = "_9i-0";
export var cardWrapper = "_9i-9";
export var fieldName = "_9i-3";
export var newValue = "_9i-6";
export var oldValue = "_9i-4";
export var orangeGlowFade = "_9i-c";
export var productSection = "_9i-1";
export var scrollToBottom = "_9i-b";
export var scrollToBottomAnchor = "_9i-a";
export var scrollToBottomIcon = "_9i-d";
export var showAllButton = "_9i-7";
export var table = "_9i-2";